import { TabPane, Tabs, theme } from 'components';
import { ExternalListing } from 'contexts';
import React from 'react';
import styled from 'styled-components';

export const MY_SHOWINGS = 'MY_SHOWINGS';

const ExternalNotificationHeader = ({
  address,
  listings,
  activeTab,
  setActiveTab,
  hasBuyerShowings = false,
}: {
  hasBuyerShowings: boolean;
  address?: string;
  listings?: ExternalListing[];
  activeTab?: string;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
}) => (
    <div className="normalheader transition animated fadeIn">
      <div className="hpanel">
        <StyledContainer className="panel-body">
          <h2 className="font-light">
            <div className="row">
              <div className="col-md-12">
                <>Notifications</>
              </div>
            </div>
          </h2>
          <StyledTabs onChange={key => setActiveTab(key)} activeKey={activeTab}>
            {hasBuyerShowings && (
              <TabPane
                tab="My Showings"
                tabKey={MY_SHOWINGS}
                key={MY_SHOWINGS}
              />
            )}
            {listings.map(listing => (
                <TabPane
                  tab={`${listing.line1} ${listing?.line2 || ''}`}
                  tabKey={listing.id}
                  key={listing.id}
                />
              ))}
          </StyledTabs>
        </StyledContainer>
      </div>
    </div>
  );

export default ExternalNotificationHeader;

const StyledContainer = styled.div`
  padding-bottom: 0px !important;
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0;
    border: 0;
    background-color: ${theme.white};
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${theme.blueBase};
  }
`;
